/**
 * Spec 217 PR4.b — English translation table.
 * Mirror shape of `es.ts` — see that file for key conventions.
 */
import type { ResourceShape } from './es';

export const en: ResourceShape = {
  common: {
    save: 'Save',
    saved: 'Saved',
    cancel: 'Cancel',
    back: 'Back',
    loading: 'Loading…',
  },
  sidebar: {
    works: 'Jobs',
    newWork: 'New job',
    stats: 'Stats',
    clients: 'Clients',
    broadcasts: 'Announcements',
    settings: 'Settings',
  },
  settings: {
    title: 'Settings',
    profile: 'Profile',
    profileName: 'Name',
    profileRole: 'Role',
    profileCompanyId: 'Company ID',
    profilePaired: 'Paired',
    team: 'Team',
    teamName: 'Team name',
    companyName: 'Company name',
    members: 'Members',
    youBadge: 'YOU',
    membersEmpty: 'No team members synced yet.',
    memberJoinedAt: 'Member since {{date}}',
    teamReadonlyHint: 'only the owner can change it',
    teamErrorEmpty: 'Name cannot be empty.',
    teamErrorTooLong: 'Name must be 80 characters or less.',
    appearance: 'Appearance',
    appearanceTheme: 'Theme',
    appearanceThemeAuto: 'Auto',
    appearanceThemeLight: 'Light',
    appearanceThemeDark: 'Dark',
    appearanceFontSize: 'Text size',
    appearanceFontSizeSmall: 'Compact',
    appearanceFontSizeMedium: 'Normal',
    appearanceFontSizeLarge: 'Large',
    language: 'Language',
    languageEs: 'Español',
    languageEn: 'English',
    logout: 'Log out',
    brandingTitle: 'Company identity',
    brandingDescription: 'Shown on every PDF you generate from Cuadrilla.',
    brandingCompanyName: 'Legal name',
    brandingTaxId: 'Tax ID',
    brandingPhone: 'Phone',
    brandingEmail: 'Email',
    brandingEmailInvalid: 'Check the email format.',
    brandingWeb: 'Website',
    brandingLogoMobileOnly: 'Logo: edit from the mobile app',
    brandingUploadLogo: 'Upload logo',
    brandingChangeLogo: 'Change logo',
    brandingRemoveLogo: 'Remove logo',
    brandingLogoTooLarge: 'Logo too large (max 256 KB).',
    brandingLogoHint: 'PNG, JPG or SVG, max 256 KB.',
    brandingSaved: 'Saved',
  },
  pair: {
    brandName: 'Cuadrilla web',
    heroTitle: 'Your jobs, on any screen',
    heroTagline: 'Pair this browser with your phone to write notes, review photos and export PDFs — without losing end-to-end privacy.',
    bullet1Title: 'End-to-end encrypted.',
    bullet1Body: 'The server only sees noise — not even we can read your jobs.',
    bullet2Title: 'Your phone stays in control.',
    bullet2Body: 'Camera, signature and voice stay on the primary device.',
    bullet3Title: 'macOS, Windows and Linux.',
    bullet3Body: 'Nothing to install — a modern browser is enough.',
    mainTitle: 'Pair with your phone',
    step1: 'Open Cuadrilla on your phone.',
    step2: 'Go to <1>Settings → «Cuadrilla web»</1>.',
    step3: 'Scan this code.',
    generating: 'Generating secure QR…',
    expired: 'QR expired, generating a new one…',
    qrAlt: 'QR code to pair your phone',
    codeLabel: 'Verification code',
    codeHint: 'Check it matches what you see on your phone before confirming.',
    paired: 'Paired. Loading your jobs…',
    error: 'Could not pair.',
    retry: 'Retry',
    caveatTitle: 'The browser cannot block screenshots.',
    caveatBody: 'Unlike the mobile app, browser extensions, system tools and desktop recordings can see this tab. Log out when you\'re done and avoid using Cuadrilla web on shared computers.',
  },
};
